import { useState } from "react";
import useFeedbackService from "../../../barrel/hooks/useFeedbackService";
import useHxfTranslation from "../../../barrel/hooks/useHxfTranslation";
import useLocalStorageHandler from "../../../barrel/hooks/useLocalStorageHandler";
import CustomArrowBack from "../../CustomElements/CustomArrowBack/CustomArrowBack";
import InAppTemplate from "../../InAppTemplate/InAppTemplate";
import styles from "./DemoLimitedAccess.module.scss";
import { IonButton, IonIcon } from "@ionic/react";
import NewReleasesIcon from '@mui/icons-material/NewReleases';
import { Trans } from "react-i18next";
function DemoLimitedAccess(props:any) {
  const {t} = useHxfTranslation();
  const [showLabelsScanner, setShowLabelsScanner] = useState(false);
  const myLocalStorage = useLocalStorageHandler();
  const [isLoading, setIsLoading] = useState(false);
  const feedbackService = useFeedbackService();
  const [sfs03Popup, setSfs03Popup] = useState<any>(null);

  return (
    <InAppTemplate>

      <CustomArrowBack pushUrl="/home" />
      <div className={styles.pageTitle}>{t("demo.mode")}</div>
  
      <div className={styles.optionsContainer}>
        <div className={styles.optionsContent}>
            <div>
                <div className={styles.optionsContent}><NewReleasesIcon fontSize={"large"} style={{color:'rgb(220 187 164)'}}/></div>
                <div><Trans i18nKey={'feature.not.available.demo.mode'}  defaults={'ffeature.not.available.demo.mode'} components={{ bold: <strong /> }}/></div>
                <div className={styles.optionsContent}>
                    <a href="https://haxify.com/shopfloor-studio/schedule-demo"  rel="noreferrer" target="_blank">
                    <IonButton
                      color="warning"
                      size={"default"}
                      style={{width:'100%'}}
                     
                      className={styles.confirmButton}
                      onClick={() => {
 
                      }}
                    >
                    
                       {t('schedule.full.demo')}
                  </IonButton>
                    </a>
                    </div>
            </div>
        </div>
      </div>
    </InAppTemplate>
  );
}

export default DemoLimitedAccess;
